function PendingJobsService(ApiService, AppSettings) {
    'ngInject';
    const service = {};

    service.listPendingJobs = function(url, callbackFunc){
      ApiService.get(url, callbackFunc);
  };

  service.delete =function(orgId,background_jobs_id,callbackFunc){
    console.log(`${orgId}`)
    console.log(`${background_jobs_id}`)
    console.log(`${AppSettings.apiUrl}/organizations/${orgId}/background_jobs/${background_jobs_id}.json`);
    ApiService.delete(`/organizations/${orgId}/background_jobs/${background_jobs_id}.json`, {}, callbackFunc);
  };

  return service;
}
export default {
  name: 'PendingJobsService',
  fn: PendingJobsService
};
